import { Component, OnInit } from '@angular/core';
import { AssetService } from '../../../../services/asset.service';

@Component({
    selector: 'app-copy-hud',
    templateUrl: './copy-hud.component.html',
    styleUrls: ['./copy-hud.component.scss'],
    standalone: true
})
export class CopyHudComponent implements OnInit {

    imgSrc: string;

    constructor(public assetService: AssetService) {
    }

    ngOnInit(): void {
        this.imgSrc = this.assetService.getUrl('icon-buchlink-weiss-seiterechts.png');
    }

}
